export const REALTY_HEADER_OFFER_TYPE_IDS = {
  buy: 2,
  rent: 1,
} as const;

export const REALTY_HEADER_TYPE_IDS = [12, 1, 14, 13] as const;

const SELL_PATH_SEGMENT = 'odkupime-nehnutelnost';

export function isRealtyHeaderSellPath(path?: string | null) {
  return path?.toLocaleLowerCase('sk').includes(SELL_PATH_SEGMENT) ?? false;
}

export function isSupportedRealtyHeaderTypeId(
  typeId: number,
): typeId is (typeof REALTY_HEADER_TYPE_IDS)[number] {
  return (REALTY_HEADER_TYPE_IDS as readonly number[]).includes(typeId);
}

export function buildRealtyHeaderIntentHref(route: string, typeId: number, offerTypeId?: number) {
  const params = new URLSearchParams({ type: String(typeId) });
  if (offerTypeId !== undefined) params.set('offer_type', String(offerTypeId));
  return `${route}${route.includes('?') ? '&' : '?'}${params.toString()}`;
}
